import { isDef } from '@lhb/func';
import { fixNumberSE } from '@/common/utils/ways';

export interface MockDemo {
  a: Function;
}
// export const diyShape = 'diyShape';
// 此处与服务端的枚举相同，勿轻易修改。
export const typeEnum = {
  /** 半径 */
  radius: 1,
  /** 自定义形状 */
  diyShape: 2,
  /** 步行 */
  walk: 3,
  /** 骑行 */
  ride: 4,
  /** 驾车 */
  drive: 5
};
export const typeOptions = [
  { label: '半径', value: typeEnum.radius },
  { label: '自定义形状', value: typeEnum.diyShape },
  { label: '步行', value: typeEnum.walk },
  { label: '骑行', value: typeEnum.ride },
  { label: '驾车', value: typeEnum.drive },
];

/** 获取查询方式名称 */
export function getSearchTypeNameByValue(value: number) {
  const item = typeOptions.find((item: any) => item.value === value);
  return item?.label || '';
}

export const radiusOptions = [
  { label: '0.5km', value: 500 },
  { label: '1km', value: 1000 },
  { label: '2km', value: 2000 },
  { label: '3km', value: 3000 },
  { label: '4km', value: 4000 },
  { label: '5km', value: 5000 },
];

/** 获取半径名称 */
export function getRadiusNameByValue(value: number) {
  const item = radiusOptions.find((item: any) => item.value === value);
  if (item?.label) {
    return item.label;
  } else {
    return isDef(value) ? (+value < 1000 ? `${+value}m` : `${fixNumberSE(value / 1000.0)}km`) : '-';
  }
}

/** 搜索时间选择项 */
export const timeOptions = [
  { label: '5分钟', value: 5 },
  { label: '10分钟', value: 10 },
  { label: '15分钟', value: 15 },
  { label: '20分钟', value: 20 },
];

/** 获取搜索时间名称 */
export function getTimeNameByValue(value: number) {
  const item = timeOptions.find((item: any) => item.value === value);
  return item?.label || '';
}

export const styleConfig = {
  strokeColor: '#0A9999',
  strokeOpacity: 1,
  strokeWeight: 2,
  strokeStyle: 'dashed',
  fillColor: '#07B4B4',
  fillOpacity: 0.2,
  color: '#006AFF',
};

export const mockPolygon = [
  {
    'lng': 120.136756,
    'lat': 30.276419
  },
  {
    'lng': 120.136721,
    'lat': 30.275443
  },
  {
    'lng': 120.136721,
    'lat': 30.275435
  },
  {
    'lng': 120.136719,
    'lat': 30.275428
  },
  {
    'lng': 120.136717,
    'lat': 30.27542
  },
  {
    'lng': 120.136714,
    'lat': 30.275413
  },
  {
    'lng': 120.13671,
    'lat': 30.275406
  },
  {
    'lng': 120.136706,
    'lat': 30.275399
  },
  {
    'lng': 120.136701,
    'lat': 30.275393
  },
  {
    'lng': 120.136695,
    'lat': 30.275387
  },
  {
    'lng': 120.136689,
    'lat': 30.275382
  },
  {
    'lng': 120.136683,
    'lat': 30.275378
  },
  {
    'lng': 120.136676,
    'lat': 30.275374
  },
  {
    'lng': 120.136668,
    'lat': 30.275371
  },
  {
    'lng': 120.136661,
    'lat': 30.275369
  },
  {
    'lng': 120.136653,
    'lat': 30.275367
  },
  {
    'lng': 120.136645,
    'lat': 30.275366
  },
  {
    'lng': 120.136637,
    'lat': 30.275366
  },
  {
    'lng': 120.136629,
    'lat': 30.275367
  },
  {
    'lng': 120.136622,
    'lat': 30.275369
  },
  {
    'lng': 120.136614,
    'lat': 30.275371
  },
  {
    'lng': 120.136607,
    'lat': 30.275374
  },
  {
    'lng': 120.1366,
    'lat': 30.275378
  },
  {
    'lng': 120.136593,
    'lat': 30.275382
  },
  {
    'lng': 120.136587,
    'lat': 30.275387
  },
  {
    'lng': 120.136582,
    'lat': 30.275393
  },
  {
    'lng': 120.136577,
    'lat': 30.275399
  },
  {
    'lng': 120.136572,
    'lat': 30.275406
  },
  {
    'lng': 120.136569,
    'lat': 30.275413
  },
  {
    'lng': 120.136353,
    'lat': 30.275878
  },
  {
    'lng': 120.13635,
    'lat': 30.275885
  },
  {
    'lng': 120.136348,
    'lat': 30.275892
  },
  {
    'lng': 120.136347,
    'lat': 30.2759
  },
  {
    'lng': 120.136346,
    'lat': 30.275907
  },
  {
    'lng': 120.136346,
    'lat': 30.275915
  },
  {
    'lng': 120.136347,
    'lat': 30.275922
  },
  {
    'lng': 120.136348,
    'lat': 30.27593
  },
  {
    'lng': 120.13635,
    'lat': 30.275937
  },
  {
    'lng': 120.136353,
    'lat': 30.275944
  },
  {
    'lng': 120.136356,
    'lat': 30.275951
  },
  {
    'lng': 120.13636,
    'lat': 30.275958
  },
  {
    'lng': 120.136365,
    'lat': 30.275964
  },
  {
    'lng': 120.13637,
    'lat': 30.275969
  },
  {
    'lng': 120.13639,
    'lat': 30.275988
  },
  {
    'lng': 120.135683,
    'lat': 30.276793
  },
  {
    'lng': 120.135124,
    'lat': 30.277381
  },
  {
    'lng': 120.135119,
    'lat': 30.277387
  },
  {
    'lng': 120.135114,
    'lat': 30.277393
  },
  {
    'lng': 120.13511,
    'lat': 30.2774
  },
  {
    'lng': 120.135107,
    'lat': 30.277408
  },
  {
    'lng': 120.135105,
    'lat': 30.277415
  },
  {
    'lng': 120.135103,
    'lat': 30.277423
  },
  {
    'lng': 120.135102,
    'lat': 30.277431
  },
  {
    'lng': 120.135102,
    'lat': 30.277439
  },
  {
    'lng': 120.135103,
    'lat': 30.277447
  },
  {
    'lng': 120.135104,
    'lat': 30.277454
  },
  {
    'lng': 120.135106,
    'lat': 30.277462
  },
  {
    'lng': 120.135109,
    'lat': 30.277469
  },
  {
    'lng': 120.135113,
    'lat': 30.277476
  },
  {
    'lng': 120.135117,
    'lat': 30.277483
  },
  {
    'lng': 120.135122,
    'lat': 30.277489
  },
  {
    'lng': 120.135128,
    'lat': 30.277495
  },
  {
    'lng': 120.135134,
    'lat': 30.2775
  },
  {
    'lng': 120.13514,
    'lat': 30.277504
  },
  {
    'lng': 120.135147,
    'lat': 30.277508
  },
  {
    'lng': 120.135155,
    'lat': 30.277511
  },
  {
    'lng': 120.135162,
    'lat': 30.277514
  },
  {
    'lng': 120.13517,
    'lat': 30.277515
  },
  {
    'lng': 120.135178,
    'lat': 30.277516
  },
  {
    'lng': 120.135186,
    'lat': 30.277516
  },
  {
    'lng': 120.135194,
    'lat': 30.277515
  },
  {
    'lng': 120.135201,
    'lat': 30.277514
  },
  {
    'lng': 120.135209,
    'lat': 30.277511
  },
  {
    'lng': 120.135216,
    'lat': 30.277508
  },
  {
    'lng': 120.135223,
    'lat': 30.277505
  },
  {
    'lng': 120.135377,
    'lat': 30.277411
  },
  {
    'lng': 120.13591,
    'lat': 30.27712
  },
  {
    'lng': 120.136588,
    'lat': 30.27699
  },
  {
    'lng': 120.136622,
    'lat': 30.277
  },
  {
    'lng': 120.136626,
    'lat': 30.277001
  },
  {
    'lng': 120.136859,
    'lat': 30.27706
  },
  {
    'lng': 120.136861,
    'lat': 30.277061
  },
  {
    'lng': 120.136887,
    'lat': 30.277067
  },
  {
    'lng': 120.136894,
    'lat': 30.277068
  },
  {
    'lng': 120.136901,
    'lat': 30.277069
  },
  {
    'lng': 120.136908,
    'lat': 30.277069
  },
  {
    'lng': 120.137126,
    'lat': 30.277061
  },
  {
    'lng': 120.137265,
    'lat': 30.277366
  },
  {
    'lng': 120.137269,
    'lat': 30.277373
  },
  {
    'lng': 120.137273,
    'lat': 30.277379
  },
  {
    'lng': 120.137278,
    'lat': 30.277385
  },
  {
    'lng': 120.137283,
    'lat': 30.277391
  },
  {
    'lng': 120.137289,
    'lat': 30.277396
  },
  {
    'lng': 120.137295,
    'lat': 30.2774
  },
  {
    'lng': 120.137302,
    'lat': 30.277404
  },
  {
    'lng': 120.137309,
    'lat': 30.277407
  },
  {
    'lng': 120.137316,
    'lat': 30.277409
  },
  {
    'lng': 120.137324,
    'lat': 30.277411
  },
  {
    'lng': 120.137331,
    'lat': 30.277412
  },
  {
    'lng': 120.137339,
    'lat': 30.277412
  },
  {
    'lng': 120.137347,
    'lat': 30.277412
  },
  {
    'lng': 120.137355,
    'lat': 30.277411
  },
  {
    'lng': 120.137362,
    'lat': 30.277409
  },
  {
    'lng': 120.137369,
    'lat': 30.277406
  },
  {
    'lng': 120.137376,
    'lat': 30.277403
  },
  {
    'lng': 120.137383,
    'lat': 30.277399
  },
  {
    'lng': 120.137389,
    'lat': 30.277394
  },
  {
    'lng': 120.137395,
    'lat': 30.277389
  },
  {
    'lng': 120.1374,
    'lat': 30.277383
  },
  {
    'lng': 120.137404,
    'lat': 30.277377
  },
  {
    'lng': 120.137408,
    'lat': 30.27737
  },
  {
    'lng': 120.137412,
    'lat': 30.277363
  },
  {
    'lng': 120.137414,
    'lat': 30.277356
  },
  {
    'lng': 120.137416,
    'lat': 30.277348
  },
  {
    'lng': 120.137417,
    'lat': 30.277341
  },
  {
    'lng': 120.137449,
    'lat': 30.277032
  },
  {
    'lng': 120.13745,
    'lat': 30.277024
  },
  {
    'lng': 120.137449,
    'lat': 30.277016
  },
  {
    'lng': 120.137448,
    'lat': 30.277008
  },
  {
    'lng': 120.137446,
    'lat': 30.277
  },
  {
    'lng': 120.137443,
    'lat': 30.276992
  },
  {
    'lng': 120.13744,
    'lat': 30.276985
  },
  {
    'lng': 120.137436,
    'lat': 30.276978
  },
  {
    'lng': 120.137435,
    'lat': 30.276977
  },
  {
    'lng': 120.137434,
    'lat': 30.276973
  },
  {
    'lng': 120.137433,
    'lat': 30.276965
  },
  {
    'lng': 120.137431,
    'lat': 30.276957
  },
  {
    'lng': 120.137429,
    'lat': 30.27695
  },
  {
    'lng': 120.137425,
    'lat': 30.276943
  },
  {
    'lng': 120.137421,
    'lat': 30.276936
  },
  {
    'lng': 120.137417,
    'lat': 30.27693
  },
  {
    'lng': 120.137411,
    'lat': 30.276924
  },
  {
    'lng': 120.137405,
    'lat': 30.276919
  },
  {
    'lng': 120.137399,
    'lat': 30.276914
  },
  {
    'lng': 120.137392,
    'lat': 30.27691
  },
  {
    'lng': 120.137385,
    'lat': 30.276906
  },
  {
    'lng': 120.137378,
    'lat': 30.276904
  },
  {
    'lng': 120.13737,
    'lat': 30.276902
  },
  {
    'lng': 120.137362,
    'lat': 30.276901
  },
  {
    'lng': 120.137355,
    'lat': 30.2769
  },
  {
    'lng': 120.137231,
    'lat': 30.276901
  },
  {
    'lng': 120.137222,
    'lat': 30.276901
  },
  {
    'lng': 120.137219,
    'lat': 30.276889
  },
  {
    'lng': 120.137219,
    'lat': 30.276886
  },
  {
    'lng': 120.137219,
    'lat': 30.276878
  },
  {
    'lng': 120.137218,
    'lat': 30.27687
  },
  {
    'lng': 120.137216,
    'lat': 30.276862
  },
  {
    'lng': 120.137213,
    'lat': 30.276855
  },
  {
    'lng': 120.13721,
    'lat': 30.276848
  },
  {
    'lng': 120.137205,
    'lat': 30.276841
  },
  {
    'lng': 120.137201,
    'lat': 30.276834
  },
  {
    'lng': 120.137195,
    'lat': 30.276829
  },
  {
    'lng': 120.137189,
    'lat': 30.276823
  },
  {
    'lng': 120.137183,
    'lat': 30.276819
  },
  {
    'lng': 120.137176,
    'lat': 30.276815
  },
  {
    'lng': 120.137169,
    'lat': 30.276811
  },
  {
    'lng': 120.137161,
    'lat': 30.276809
  },
  {
    'lng': 120.137154,
    'lat': 30.276807
  },
  {
    'lng': 120.137146,
    'lat': 30.276806
  },
  {
    'lng': 120.137138,
    'lat': 30.276806
  },
  {
    'lng': 120.13713,
    'lat': 30.276806
  },
  {
    'lng': 120.137122,
    'lat': 30.276808
  },
  {
    'lng': 120.137114,
    'lat': 30.27681
  },
  {
    'lng': 120.137107,
    'lat': 30.276812
  },
  {
    'lng': 120.136943,
    'lat': 30.276884
  },
  {
    'lng': 120.136793,
    'lat': 30.276571
  },
  {
    'lng': 120.136789,
    'lat': 30.276563
  },
  {
    'lng': 120.136785,
    'lat': 30.276557
  },
  {
    'lng': 120.136745,
    'lat': 30.276505
  },
  {
    'lng': 120.136755,
    'lat': 30.276434
  },
  {
    'lng': 120.136756,
    'lat': 30.276426
  },
  {
    'lng': 120.136756,
    'lat': 30.276419
  }
];
export const mockPolygon2 = [
  {
    'lng': 120.141106,
    'lat': 30.284057
  },
  {
    'lng': 120.141106,
    'lat': 30.284063
  },
  {
    'lng': 120.141107,
    'lat': 30.284073
  },
  {
    'lng': 120.141111,
    'lat': 30.284104
  },
  {
    'lng': 120.141089,
    'lat': 30.284156
  },
  {
    'lng': 120.141086,
    'lat': 30.284166
  },
  {
    'lng': 120.141084,
    'lat': 30.284176
  },
  {
    'lng': 120.141082,
    'lat': 30.284185
  },
  {
    'lng': 120.141082,
    'lat': 30.284195
  },
  {
    'lng': 120.141083,
    'lat': 30.284205
  },
  {
    'lng': 120.141084,
    'lat': 30.284215
  },
  {
    'lng': 120.141087,
    'lat': 30.284225
  },
  {
    'lng': 120.14109,
    'lat': 30.284234
  },
  {
    'lng': 120.141095,
    'lat': 30.284243
  },
  {
    'lng': 120.1411,
    'lat': 30.284251
  },
  {
    'lng': 120.141106,
    'lat': 30.284259
  },
  {
    'lng': 120.141113,
    'lat': 30.284267
  },
  {
    'lng': 120.141121,
    'lat': 30.284273
  },
  {
    'lng': 120.141129,
    'lat': 30.284279
  },
  {
    'lng': 120.141138,
    'lat': 30.284284
  },
  {
    'lng': 120.141147,
    'lat': 30.284288
  },
  {
    'lng': 120.141156,
    'lat': 30.284291
  },
  {
    'lng': 120.141166,
    'lat': 30.284293
  },
  {
    'lng': 120.141176,
    'lat': 30.284294
  },
  {
    'lng': 120.141186,
    'lat': 30.284294
  },
  {
    'lng': 120.141196,
    'lat': 30.284293
  },
  {
    'lng': 120.141206,
    'lat': 30.284291
  },
  {
    'lng': 120.141215,
    'lat': 30.284288
  },
  {
    'lng': 120.141224,
    'lat': 30.284285
  },
  {
    'lng': 120.141233,
    'lat': 30.28428
  },
  {
    'lng': 120.141242,
    'lat': 30.284275
  },
  {
    'lng': 120.141249,
    'lat': 30.284268
  },
  {
    'lng': 120.141256,
    'lat': 30.284261
  },
  {
    'lng': 120.141263,
    'lat': 30.284253
  },
  {
    'lng': 120.141296,
    'lat': 30.284208
  },
  {
    'lng': 120.141301,
    'lat': 30.284208
  },
  {
    'lng': 120.14131,
    'lat': 30.284206
  },
  {
    'lng': 120.14132,
    'lat': 30.284203
  },
  {
    'lng': 120.141329,
    'lat': 30.284199
  },
  {
    'lng': 120.141337,
    'lat': 30.284195
  },
  {
    'lng': 120.141345,
    'lat': 30.284189
  },
  {
    'lng': 120.141353,
    'lat': 30.284183
  },
  {
    'lng': 120.141363,
    'lat': 30.284174
  },
  {
    'lng': 120.14137,
    'lat': 30.284167
  },
  {
    'lng': 120.141376,
    'lat': 30.28416
  },
  {
    'lng': 120.141381,
    'lat': 30.284152
  },
  {
    'lng': 120.141386,
    'lat': 30.284143
  },
  {
    'lng': 120.14139,
    'lat': 30.284134
  },
  {
    'lng': 120.141393,
    'lat': 30.284125
  },
  {
    'lng': 120.141395,
    'lat': 30.284115
  },
  {
    'lng': 120.141396,
    'lat': 30.284105
  },
  {
    'lng': 120.141396,
    'lat': 30.284096
  },
  {
    'lng': 120.141395,
    'lat': 30.284086
  },
  {
    'lng': 120.141393,
    'lat': 30.284076
  },
  {
    'lng': 120.14139,
    'lat': 30.284067
  },
  {
    'lng': 120.141387,
    'lat': 30.284058
  },
  {
    'lng': 120.141382,
    'lat': 30.284049
  },
  {
    'lng': 120.141377,
    'lat': 30.284041
  },
  {
    'lng': 120.141377,
    'lat': 30.284041
  },
  {
    'lng': 120.14138,
    'lat': 30.284033
  },
  {
    'lng': 120.141384,
    'lat': 30.284024
  },
  {
    'lng': 120.141387,
    'lat': 30.284014
  },
  {
    'lng': 120.141388,
    'lat': 30.284005
  },
  {
    'lng': 120.141389,
    'lat': 30.283995
  },
  {
    'lng': 120.141388,
    'lat': 30.283985
  },
  {
    'lng': 120.141387,
    'lat': 30.283975
  },
  {
    'lng': 120.141385,
    'lat': 30.283965
  },
  {
    'lng': 120.141379,
    'lat': 30.283945
  },
  {
    'lng': 120.141381,
    'lat': 30.28394
  },
  {
    'lng': 120.141385,
    'lat': 30.283932
  },
  {
    'lng': 120.141388,
    'lat': 30.283923
  },
  {
    'lng': 120.14139,
    'lat': 30.283913
  },
  {
    'lng': 120.141391,
    'lat': 30.283904
  },
  {
    'lng': 120.141391,
    'lat': 30.283895
  },
  {
    'lng': 120.14139,
    'lat': 30.283885
  },
  {
    'lng': 120.141388,
    'lat': 30.283876
  },
  {
    'lng': 120.141386,
    'lat': 30.283867
  },
  {
    'lng': 120.141366,
    'lat': 30.283806
  },
  {
    'lng': 120.141584,
    'lat': 30.283773
  },
  {
    'lng': 120.141593,
    'lat': 30.283772
  },
  {
    'lng': 120.141602,
    'lat': 30.283769
  },
  {
    'lng': 120.141611,
    'lat': 30.283765
  },
  {
    'lng': 120.141619,
    'lat': 30.283761
  },
  {
    'lng': 120.141627,
    'lat': 30.283756
  },
  {
    'lng': 120.141635,
    'lat': 30.28375
  },
  {
    'lng': 120.142159,
    'lat': 30.283293
  },
  {
    'lng': 120.142166,
    'lat': 30.283286
  },
  {
    'lng': 120.142173,
    'lat': 30.283279
  },
  {
    'lng': 120.142178,
    'lat': 30.283271
  },
  {
    'lng': 120.142183,
    'lat': 30.283263
  },
  {
    'lng': 120.142187,
    'lat': 30.283254
  },
  {
    'lng': 120.14219,
    'lat': 30.283245
  },
  {
    'lng': 120.142192,
    'lat': 30.283235
  },
  {
    'lng': 120.142193,
    'lat': 30.283226
  },
  {
    'lng': 120.142194,
    'lat': 30.283216
  },
  {
    'lng': 120.142193,
    'lat': 30.283206
  },
  {
    'lng': 120.142191,
    'lat': 30.283197
  },
  {
    'lng': 120.142189,
    'lat': 30.283187
  },
  {
    'lng': 120.142186,
    'lat': 30.283178
  },
  {
    'lng': 120.142181,
    'lat': 30.28317
  },
  {
    'lng': 120.142176,
    'lat': 30.283161
  },
  {
    'lng': 120.14217,
    'lat': 30.283154
  },
  {
    'lng': 120.142164,
    'lat': 30.283147
  },
  {
    'lng': 120.142157,
    'lat': 30.28314
  },
  {
    'lng': 120.142149,
    'lat': 30.283134
  },
  {
    'lng': 120.142141,
    'lat': 30.283129
  },
  {
    'lng': 120.142132,
    'lat': 30.283125
  },
  {
    'lng': 120.142123,
    'lat': 30.283122
  },
  {
    'lng': 120.142113,
    'lat': 30.28312
  },
  {
    'lng': 120.142104,
    'lat': 30.283118
  },
  {
    'lng': 120.142094,
    'lat': 30.283118
  },
  {
    'lng': 120.142084,
    'lat': 30.283118
  },
  {
    'lng': 120.142075,
    'lat': 30.28312
  },
  {
    'lng': 120.142065,
    'lat': 30.283122
  },
  {
    'lng': 120.142056,
    'lat': 30.283125
  },
  {
    'lng': 120.141237,
    'lat': 30.283457
  },
  {
    'lng': 120.141205,
    'lat': 30.283455
  },
  {
    'lng': 120.141168,
    'lat': 30.283453
  },
  {
    'lng': 120.140978,
    'lat': 30.283382
  },
  {
    'lng': 120.140968,
    'lat': 30.283379
  },
  {
    'lng': 120.140959,
    'lat': 30.283377
  },
  {
    'lng': 120.140949,
    'lat': 30.283376
  },
  {
    'lng': 120.140939,
    'lat': 30.283375
  },
  {
    'lng': 120.140929,
    'lat': 30.283376
  },
  {
    'lng': 120.140919,
    'lat': 30.283378
  },
  {
    'lng': 120.14091,
    'lat': 30.283381
  },
  {
    'lng': 120.1409,
    'lat': 30.283385
  },
  {
    'lng': 120.140892,
    'lat': 30.283389
  },
  {
    'lng': 120.140883,
    'lat': 30.283395
  },
  {
    'lng': 120.140876,
    'lat': 30.283401
  },
  {
    'lng': 120.140869,
    'lat': 30.283408
  },
  {
    'lng': 120.140862,
    'lat': 30.283416
  },
  {
    'lng': 120.140857,
    'lat': 30.283424
  },
  {
    'lng': 120.140852,
    'lat': 30.283433
  },
  {
    'lng': 120.140848,
    'lat': 30.283442
  },
  {
    'lng': 120.140846,
    'lat': 30.283451
  },
  {
    'lng': 120.140844,
    'lat': 30.283461
  },
  {
    'lng': 120.140843,
    'lat': 30.283471
  },
  {
    'lng': 120.140843,
    'lat': 30.283481
  },
  {
    'lng': 120.140844,
    'lat': 30.283491
  },
  {
    'lng': 120.140846,
    'lat': 30.283501
  },
  {
    'lng': 120.140849,
    'lat': 30.28351
  },
  {
    'lng': 120.140853,
    'lat': 30.283519
  },
  {
    'lng': 120.140858,
    'lat': 30.283528
  },
  {
    'lng': 120.140863,
    'lat': 30.283536
  },
  {
    'lng': 120.14087,
    'lat': 30.283544
  },
  {
    'lng': 120.141157,
    'lat': 30.283851
  },
  {
    'lng': 120.141162,
    'lat': 30.2839
  },
  {
    'lng': 120.141143,
    'lat': 30.283935
  },
  {
    'lng': 120.141126,
    'lat': 30.283962
  },
  {
    'lng': 120.141121,
    'lat': 30.283971
  },
  {
    'lng': 120.141117,
    'lat': 30.283981
  },
  {
    'lng': 120.141114,
    'lat': 30.283991
  },
  {
    'lng': 120.141112,
    'lat': 30.284001
  },
  {
    'lng': 120.141107,
    'lat': 30.284037
  },
  {
    'lng': 120.141106,
    'lat': 30.284048
  },
  {
    'lng': 120.141106,
    'lat': 30.284057
  }
];
